import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'

import { cache, cacheClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation ClearCache {
    clear
  }
`

export const useClearCache = () => {
  const [request, state] = useMutation(MUTATION, { client: cacheClient })
  const notify = useNotification()
  const modal = useAlert()

  const handleRequest = ids => {
    if (!modal.confirm({ title: 'Certeza que deseja limpar o cache?' })) return false

    return request({}).then(resp => {
      if (!resp.errors) {
        cache.reset()
        notify.success({ title: 'Cache limpo com sucesso!' })
      } else {
        notify.error({ title: 'Ocorreu um erro ao limpar o cache!' })
      }
    })
  }

  return [handleRequest, state]
}
